import(/* webpackMode: "eager" */ "/tebuto/webapp/app/error.tsx");
